var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 20.3999C11.5886 20.3999 8.16 18.4799 6.10286 15.3256C5.96571 15.0513 5.96571 14.777 6.10286 14.6399C8.16 11.3485 11.5886 9.42847 15.4286 9.42847C19.2686 9.42847 22.6971 11.3485 24.7543 14.5028C24.8914 14.777 24.8914 15.0513 24.7543 15.1885C22.6971 18.4799 19.2686 20.3999 15.4286 20.3999ZM7.61143 14.9142C9.39429 17.5199 12.2743 19.0285 15.4286 19.0285C18.5829 19.0285 21.4629 17.5199 23.2457 14.9142C21.4629 12.3085 18.5829 10.7999 15.4286 10.7999C12.2743 10.7999 9.39429 12.3085 7.61143 14.9142ZM15.4286 18.3428C13.5086 18.3428 12 16.8342 12 14.9142C12 12.9942 13.5086 11.4856 15.4286 11.4856C17.3486 11.4856 18.8571 12.9942 18.8571 14.9142C18.8571 16.8342 17.3486 18.3428 15.4286 18.3428ZM15.4286 12.857C14.3314 12.857 13.3714 13.817 13.3714 14.9142C13.3714 16.0113 14.3314 16.9713 15.4286 16.9713C16.5257 16.9713 17.4857 16.0113 17.4857 14.9142C17.4857 13.817 16.5257 12.857 15.4286 12.857Z",
    fill: "#1F1F1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCircle);
export default __webpack_public_path__ + "static/media/eye-circle.4ec70da7.svg";
export { ForwardRef as ReactComponent };